import React, {Component} from 'react';
import {connect} from "react-redux";
import filter from "lodash/filter";
import get from "lodash/get";
import indexOf from "lodash/indexOf";
import { STATIC_LINKS } from "../constants";
import { HtmlSnippet } from './html-snippet';

class FooterBase extends Component {

  constructor(props){
    super(props);
    this.state = {
      monogramUrl : ''
    };
    this.footerElement = null;
  }

  componentDidMount(){
    this.initializeObserver();
  }

  componentDidUpdate(prevProp) {
    const prevMonogramUrl = get(prevProp, ['publisherTheme', 'monogram'], '');
    const monogramUrl = get(this.props, ['publisherTheme', 'monogram'], '');

    if(prevMonogramUrl !== monogramUrl) {
      this.setState({
        monogramUrl
      });
    }
  }

  initializeObserver() {
    this.footerLogoObserver = new IntersectionObserver((entries, observer) => this.setMonogramUrl(entries, observer), {
      rootMargin: '0px',
      threshold: 1.0
    });
    this.footerLogoObserver.observe(this.footerElement);
  }

  setMonogramUrl(entries, observer) {
    const entry = get(entries, [0], {});
    const monogramUrl = get(this.props, ['publisherTheme', 'monogram'], '');
    entry.isIntersecting && this.setState({monogramUrl}, () => this.footerLogoObserver && this.footerLogoObserver.disconnect());
  }

  getImageTag() {
    if(!this.state.monogramUrl)
    {
      return <img className="app-logo__element" />;
    }
    return <img className="app-logo__element" src={this.state.monogramUrl} alt={this.props.publisherName} />;
  }

render() {
    const copyrightText = get(this.props.publisherSettings, ['copyright'], '');
    const showFooterQuintypeLink = get(this.props.publisherTheme, ['footer-quintype-link'], "true") === "true";
    const bannerSource = get(this.props.publisherTheme, ['banner-source'], '');

    return <div>
      { bannerSource && <HtmlSnippet bannerSource={bannerSource} /> }
      <footer ref={el => this.footerElement = el} className="footer qt-theme__color--footerbg qt-theme__color--footer">
        <div className="footer__content">
          <div className="footer__content__first">
            {this.getImageTag()}
          </div>
          <div className="footer__content__last">
            {
              this.props.links && this.props.links.length > 0
                ? <ul>
                  {this.props.links.map((item, index) => {
                    return <li key={index}><a href={item.url}>{item.content}</a></li>
                  })}
                </ul>
                : null
            }
            <div className="copy--right">
              <div className="copy--right-text">{copyrightText}</div>
              {showFooterQuintypeLink && <a className="copy--right-link" href="https://www.quintype.com/" target="_blank" rel="noopener"><strong>Powered by quintype</strong></a>}
            </div>
          </div>
        </div>
      </footer>
    </div>;
  }
}

function mapStateToProps(state) {
  const validStaticPages = state.qt.config['theme-attributes']['static_pages'];
  const updatedStaticLinks = filter(STATIC_LINKS, (link) => {
    return indexOf(validStaticPages, link.templateKey) > -1;
  });
  return {
    links: updatedStaticLinks,
    publisherTheme: state.qt.config['theme-attributes'] || {},
    publisherSettings: state.qt.config['publisher-settings'] || {},
    publisherName: state.qt.config['publisher-name'] || ''
  }
}

export const Footer = connect(mapStateToProps, () => ({}))(FooterBase);
